var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightCeiling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.023 448H192.002C192.002 483.375 220.632 512 256.013 512S320.023 483.375 320.023 448ZM0.345 379.625C-2.531 398.75 12.972 416 32.475 416H479.55C499.053 416 514.431 398.75 511.681 379.625C495.053 263.25 399.287 172 280.017 161.125V24C280.017 10.745 269.27 0 256.013 0H256.013C242.756 0 232.009 10.745 232.009 24V161.125C112.739 172 16.972 263.25 0.345 379.625ZM51.353 368C73.482 275.625 158.371 208 256.013 208S438.543 275.625 460.672 368H51.353Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCeiling);
export default __webpack_public_path__ + "static/media/light-ceiling.53c9a03a4ddc48b09aa9f9d6667eceaf.svg";
export { ForwardRef as ReactComponent };